// Order Product Management Types
// Request types for adding products (bulk addition)

export interface IProductToAdd {
    productId?: number;
    product_id?: number;
    quantityByUnit?: number;
    count?: number;
    unitPartitionId?: number;
    unit_partition_id?: number;
    availableWeight?: number;
    available_weight?: number;
}

export interface IAddOrderProductRequest {
    storeId: number;
    products: IProductToAdd[];
}

export interface IUpdateOrderProductRequest {
    productOrderId: number;
    targetReservedQuantityByUnit?: number;
    targetQuantityByUnit?: number;
    count?: number;
    unitPartitionId?: number;
    availableWeight?: number;
    isAccepted?: boolean;
    storeId?: number;
}

export interface IRemoveOrderProductRequest {
    productOrderId: number;
}

export interface IAddOrderProductBatchAllocationRequest {
    productOrderId: number;
    batchId: number;
    quantity: number;
}

export interface IUpdateOrderProductBatchAllocationRequest {
    productOrderId: number;
    allocationId: number;
    targetQuantityByUnit?: number;
    quantityByUnit?: number;
    quantity?: number;
}

export interface IOrderProductBatchWithdrawal {
    allocationId?: number;
    batchId: number;
    quantityByUnit?: number;
    quantityAccounting?: number;
    quantity: number;
    isAddedFromStore?: boolean;
    batchNumber?: string | null;
    expirationDate?: string | null;
    purchaseDate: string;
    createdAt?: string;
    createdBy?: {
        id: number;
        firstName?: string | null;
        lastName?: string | null;
        fullName?: string | null;
        mobile?: string | null;
        cleanMobile?: string | null;
    } | null;
    storable?: any;
    enteredQuantityByUnit?: number;
    withdrawnQuantityByUnit?: number;
    availableQuantityByUnit?: number;
    enteredQuantityAccounting?: number;
    withdrawnQuantityAccounting?: number;
    availableQuantityAccounting?: number;
    availableQuantity?: number;
}

// Response types
export interface IOrderProductResponse {
    success: boolean;
    message: string;
    data?: IProductOrder;
}

export interface IOrderProductBulkResponse {
    success: boolean;
    message: string;
    data: IProductOrder[];
}

export interface IProductOrder {
    id: number;
    order_id: number;
    product_id: number;
    store_id: number;
    count: number;
    reserved_count: number;
    quantityByUnit?: number;
    requestedQuantityByUnit?: number;
    quantityAccounting?: number;
    baseQuantityByUnit?: number;
    originalRequestedQuantityByUnit?: number;
    baseQuantityAccounting?: number;
    originalRequestedQuantityAccounting?: number;
    reservedQuantityByUnit?: number;
    reservedQuantityAccounting?: number;
    factorAccountingSystem?: number;
    decimalPlaces?: number;
    quantityStepByUnit?: number;
    unit_partition_id: number;
    unit_partition_percentage: number;
    price: number;
    price_on_client: number;
    is_available: boolean;
    is_accepted: boolean;
    product: {
        id: number;
        name: string;
        description?: string;
    };
    store: {
        id: number;
        name: string;
    };
    unitPartition?: {
        id: number;
        name: string;
        percentage: number;
    };
    batchWithdrawals?: IOrderProductBatchWithdrawal[] | null;
}

// Query input method enum
export enum QuantityInputMethod {
    BY_COUNT = "count",
    BY_WEIGHT = "weight",
}
